module.exports = __webpack_public_path__ + "img/carbon-footptint-2.9534cc7d.png";